import BaseSearchScopeType from 'owa-service/lib/contract/BaseSearchScopeType';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import folderId from 'owa-service/lib/factory/folderId';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import primaryMailboxSearchScopeType from 'owa-service/lib/factory/primaryMailboxSearchScopeType';
import searchFolderScopeType from 'owa-service/lib/factory/searchFolderScopeType';

/**
 * Maps the static folder scope id in the search store to the BaseSearchScope type
 * @return BaseSearchScopeType static folder scope
 */
export default function mapFolderIdToBaseSearchScope(
    staticFolderScopeId: string
): BaseSearchScopeType[] {
    let distinguishedFolder: string;

    if (staticFolderScopeId) {
        distinguishedFolder = folderIdToName(staticFolderScopeId);
    } else {
        distinguishedFolder = 'msgfolderroot';
    }

    let folderScopeId;
    if (distinguishedFolder !== 'none') {
        folderScopeId = distinguishedFolderId({
            Id: distinguishedFolder as DistinguishedFolderIdName,
        });
    } else {
        folderScopeId = folderId({
            Id: staticFolderScopeId,
        });
    }

    return [
        primaryMailboxSearchScopeType({
            FolderScope: searchFolderScopeType({
                BaseFolderId: folderScopeId,
            }),
        }),
    ];
}
